import {t} from 'i18next';
import ArrModal from '../../../common/arr-modal/ArrModal';
import {Typography} from '@mui/material';

const ApproveProtocolModal = ({
  showModal,
  handleCancel = () => {},
  handleConfirm = () => {},
}: {
  showModal: boolean;
  handleCancel: () => void;
  handleConfirm: () => void;
}) => {
  return (
    <ArrModal
      showModal={showModal}
      onClose={() => {}}
      showClose={false}
      title={t('ai.review.protocolIntelligence.approveProtocolModalTitle')}
      aria-label={t('ai.review.protocolIntelligence.approveProtocolModalTitle')}
      dataTestId="ai-review-protocolIntelligence-approveProtocolModalTitle"
      buttons={[
        {
          id: t('common.cancel'),
          label: t('common.cancel'),
          onClick: handleCancel,
          variant: 'secondary',
          dataTestId: `${t('ai.review.protocolIntelligence.approveProtocolModalTitle')}-${t('common.cancel')}`,
        },
        {
          id: t('ai.review.protocolIntelligence.approveProtocolModalConfirm'),
          label: t(
            'ai.review.protocolIntelligence.approveProtocolModalConfirm'
          ),
          onClick: handleConfirm,
          variant: 'primary',
          dataTestId:
            'ai-review-protocolIntelligence-approveProtocolModalConfirm',
        },
      ]}
    >
      <Typography
        className="approveProtocolModalDescription-content"
        data-testid={`ai-review-protocolIntelligence-approveProtocolModalDescription`}
        aria-lable={t(
          'ai.review.protocolIntelligence.approveProtocolModalDescription'
        )}
        tabIndex={0}
      >
        {t('ai.review.protocolIntelligence.approveProtocolModalDescription')}
      </Typography>
    </ArrModal>
  );
};

export default ApproveProtocolModal;
